module.exports = __webpack_public_path__ + "img/Vue-BusApp-desktop.f2de3b7b.png";